import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons';

import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { pixelDimensions, getOrientarion } from '../../config/utils';
import { coin } from '../../assets/icons';
import { AppText, AppButton } from '../form';
import { appColors } from '../../assets/styles/global';

const Header = ({
  navigation, profilePic, canAlterPic, coins, userName, subscription,
}) => {
  const insets = useSafeAreaInsets();
  return (
    <View style={[styles.header, { marginTop: insets.top }]}>
      {
            canAlterPic
              ? (
                <AppButton onPress={() => navigation.navigate(canAlterPic)}>
                  {
                    profilePic
                      ? <Image source={{ uri: profilePic }} style={styles.imageChangePic} />
                      : <Icon name="person-circle-outline" style={styles.icon} />
                }
                </AppButton>
              )
              : (
                profilePic
                  ? (
                    <AppButton onPress={() => {}}>
                      {
                        profilePic
                          ? <Image source={{ uri: profilePic }} style={styles.imageChangePic} />
                          : <Icon name="person-circle-outline" style={styles.icon} />
                    }
                    </AppButton>
                  )
                  : <Icon name="person-circle-outline" style={[styles.icon, styles.iconSmaller]} />
              )

        }
      <View style={styles.viewUser}>
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
          <AppText style={styles.textUserName}>
            Olá,
            {' '}
            {userName}
          </AppText>
          <View style={styles.viewLine} />
          <AppText size="bold" style={styles.textUserSubscription}>{subscription || 'Bem-Vindo!'}</AppText>
        </View>
        {
                coins
                && (
                <AppButton primary disableDefaultColor onPress={() => navigation.navigate('Worker Coin Bank')} style={styles.buttonCoins}>
                  <View style={styles.viewCoins}>
                    <Image source={coin} style={styles.imageCoin} />
                    <AppText size="bold" style={styles.textCoinsNumber}>
                      {` ${coins} `}
                    </AppText>
                  </View>
                </AppButton>
                )
            }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonCoins: {
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
  },
  header: {
    backgroundColor: appColors.primary,
    flexDirection: 'row',
    paddingTop: pixelDimensions(5),
    paddingBottom: pixelDimensions(5),
    paddingHorizontal: pixelDimensions(2),
    alignItems: 'center',
  },
  icon: {
    fontSize: pixelDimensions(20),
    color: Colors.white,
  },
  iconSmaller: {
    fontSize: pixelDimensions(15),
  },
  imageSmaller: {
    height: pixelDimensions(10),
    width: pixelDimensions(10),
  },
  imageChangePic: {
    backgroundColor: 'white',
    width: pixelDimensions(15),
    height: pixelDimensions(15),
    resizeMode: 'contain',

  },
  imageCoin: {
    height: pixelDimensions(8),
    width: pixelDimensions(8) * (58 / 53),
    marginTop: pixelDimensions(3),
  },
  textUserName: {
    color: Colors.white,
    textAlign: 'center',
    fontSize: pixelDimensions(5),
  },
  textUserSubscription: {
    color: Colors.white,
    textAlign: 'center',
    fontSize: pixelDimensions(4),
  },
  textCoinsNumber: {
    fontSize: pixelDimensions(7),
    color: Colors.white,
  },
  viewChangePic: {
    alignItems: 'center',
  },
  viewCoins: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  viewLine: {
    height: 2,
    width: pixelDimensions(70),
    marginVertical: pixelDimensions(1),
    backgroundColor: Colors.white,
  },
  viewUser: {
    flex: 1,
    flexDirection: getOrientarion() === 'LANDSCAPE' ? 'row' : 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
});

export default Header;
